var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('gauge',{attrs:{"name":_vm.name,"min":_vm.min,"max":_vm.max,"value":_vm.value,"infoMessage":_vm.infoMessage}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }